import { useState, useEffect } from 'react';
import { useUser } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import getAccountInfo from '../services/Salesforce/getAccountInfo';

const useLookupInfo = () => {
  const { uuid } = useUser();
  const localAnswersKey = `${uuid}-localAnswers`;
  
  const [lookupInfo, setLookupInfo] = useState({
    company: JSON.parse(window.sessionStorage.getItem(localAnswersKey) || '{}').companyLookup?.value,
    contact: JSON.parse(window.sessionStorage.getItem(localAnswersKey) || '{}').contactLookup?.value,
  });

  const [loadingCompanyInfo, setLoadingCompanyInfo] = useState(false);

  useEffect(() => {
    if (!lookupInfo.company && !lookupInfo.contact) {
      getAccountInfo(uuid, setLookupInfo, setLoadingCompanyInfo);
    }
  }, [lookupInfo, uuid]);

  return { lookupInfo, setLookupInfo, loadingCompanyInfo };
};

export default useLookupInfo;
